import React from 'react';

type TProps = {
  value: number;
};

export function ProgressBarCircle({ value }: TProps) {
  const fullBarValue = 166;
  const emptyBarValue = 9;
  const valuePercentage = value / 100;
  const fullBarPercentage = fullBarValue - emptyBarValue;

  const calcultePercentage = fullBarValue - valuePercentage * fullBarPercentage;

  const styleSvg = {
    transform: 'rotate(270deg)',
    strokeDasharray: fullBarValue,
    strokeDashoffset: calcultePercentage,
  };

  const size = 23;
  const strokeWidth = 3;

  return (
    <svg
      height={(size + strokeWidth) * 2}
      width={(size + strokeWidth) * 2}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        id="cicle"
        cx={size + strokeWidth - 1}
        cy={size + strokeWidth}
        r={size}
        stroke="#ccc"
        fill="#ffffff00"
        strokeWidth={strokeWidth}
      />
      <circle
        cx={(size + strokeWidth) * -1}
        cy={size + strokeWidth - 1}
        r={size}
        stroke="#ff7020"
        fill="#ffffff00"
        strokeWidth={strokeWidth}
        style={styleSvg}
      />
    </svg>
  );
}
